module.exports = __webpack_public_path__ + "media/images/badges/rowhouse/17mill-inactive-0c6ef3c292fb4b581d47a13ce3655f21.png";